<template>
  <model-form
    ref="form"
    :model="itemModifierSet"
    :title="`Customize ${itemModifierSet.modifierSet.name} for ${itemName}`"
    :submodel="true"
    modal-type="modal"
    :handled-actions="['edit']"
  >
    <q-card-section>
      <div class="row q-gutter-md">
        <model-form-input
          ref="minSelectionCount"
          field="minSelectionCount"
          class="col"
          label="Minimum Selection Count"
          type="number"
          step="1"
          min="0"
          :max="itemModifierSet.modifierSet.multiselect ? itemModifierSet.maxDefaultModifiers : 1"
          clearable
          reactive-rules
          :rules="[
            val => val <= 1 || itemModifierSet.modifierSet.multiselect || 'Cannot select multiple modifiers when multiselect is disabled',
            val => $_.isNil(itemModifierSet.maxSelectionCount) || val <= itemModifierSet.maxSelectionCount || 'Can\'t be more than maximum',
            val => val <= itemModifierSet.modifierSet.minimumAvailableModifiers || 'Can\'t exceed count of available modifiers on any enabled sales channel',
          ]"
          @clear="itemModifierSet.minSelectionCount = 0"
        />
        <model-form-input
          ref="maxSelectionCount"
          field="maxSelectionCount"
          class="col"
          label="Maximum Selection Count"
          type="number"
          step="1"
          :min="itemModifierSet.minSelectionCount || 1"
          :max="itemModifierSet.maxDefaultModifiers"
          clearable
          reactive-rules
          :rules="[
            val => val === null || itemModifierSet.minSelectionCount === null || val >= itemModifierSet.minSelectionCount || 'Can\'t be less than minimum',
            val => val === null || val >= itemModifierSet.defaultSelectionCountError || 'Can\'t be less than pre-select count',
          ]"
          @clear="itemModifierSet.maxSelectionCount = null"
        />
      </div>
      <div class="row q-gutter-md">
        <q-checkbox
          :model-value="itemModifierSet.modifierSet.multiselect"
          disabled
          class="col"
          label="Allow Customer to Select Multiple Items"
          bottom-slots
        >
          <q-tooltip>
            Value is set gobally for this Modifier Set
          </q-tooltip>
        </q-checkbox>
      </div>
    </q-card-section>
    <q-card-section>
      <q-list
        bordered
        separator
      >
        <q-item
          v-for="modifier in itemModifierSet.modifierSet.modifiers.data"
          :key="modifier.id"
          class="justify-between"
          :class="{
            'bg-grey-3': disabled(modifier),
            'bg-red-2': itemModifierSet.defaultSelectionCountError && itemModifierSet.isDefaultModifier(modifier)
          }"
          :clickable="!disabled(modifier)"
          @click="itemModifierSet.toggleDefaultModifier(modifier)"
        >
          <q-item-section>
            {{ modifier.name }}
          </q-item-section>
          <q-item-section>
            <i18n-n
              :class="{ 'zero-style': !modifier.price }"
              tag="span"
              :value="modifier.price"
              format="currency"
              scope="global"
            />
          </q-item-section>
          <q-item-section style="border: solid 1px #ddd;">
            <q-checkbox
              :model-value="itemModifierSet.isDefaultModifier(modifier)"
              label="Pre-selected"
              :disable="disabled(modifier) || itemModifierSet.isTranslation"
              @update:model-value="itemModifierSet.toggleDefaultModifier(modifier)"
            />
          </q-item-section>
          <q-tooltip v-if="itemModifierSet.defaultSelectionCountError && itemModifierSet.isDefaultModifier(modifier)">
            {{ itemModifierSet.defaultSelectionCountError }}
          </q-tooltip>
        </q-item>
      </q-list>
    </q-card-section>
  </model-form>
</template>

<script>
import ModelForm from 'src/modules/admin/components/ModelForm/ModelForm'

export default {
  name: 'ItemModifierSetForm',
  components: {
    ModelForm
  },
  models: {
    itemModifierSet: {
      item: true,
      defaultModifiers: true,
      modifierSet: true
    }
  },
  computed: {
    itemName () {
      return this.itemModifierSet.item.name
    }
  },
  methods: {
    disabled (modifier) {
      return this.itemModifierSet.maxDefaultModifiersReached && !this.itemModifierSet.isDefaultModifier(modifier)
    }
  }
}

</script>

<style lang="scss" scoped>
.zero-style {
  color: #999
}
</style>
